import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "validationMessage"];

  connect() {
    this.element.dataset.formValid = "false";
  }

  validateField(event) {
    const input = event.target;
    let isValid = false;
    let message = "";

    switch (input.type) {
      case "email":
        isValid = this.validateEmail(input.value);
        message = isValid ? "" : "Please enter a valid email address";
        break;
      case "tel":
        isValid = this.validatePhone(input.value);
        message = isValid ? "" : "Please enter a valid phone number";
        break;
      case "password":
        const strength = this.getPasswordStrength(input.value);
        isValid = strength >= 3;
        message = isValid ? "" : "Password should be stronger";
        break;
    }

    this.showValidation(input, isValid, message);
    this.updateFormValidity();
  }

  validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  validatePhone(phone) {
    const phoneRegex = /^[\+]?[1-9][\d]{0,15}$/;
    return phoneRegex.test(phone.replace(/\s/g, ''));
  }

  getPasswordStrength(password) {
    let strength = 0;
    if (password.length >= 8) strength++;
    if (/[a-z]/.test(password)) strength++;
    if (/[A-Z]/.test(password)) strength++;
    if (/[0-9]/.test(password)) strength++;
    if (/[^A-Za-z0-9]/.test(password)) strength++;
    return strength;
  }

  showValidation(input, isValid, message) {
    const validationMessage = input.parentNode.querySelector('.validation-message');
    if (validationMessage) {
      validationMessage.textContent = message;
      validationMessage.style.color = isValid ? '#22c55e' : '#ef4444';
    }

    input.style.borderColor = isValid ? '#22c55e' : '#ef4444';
  }

  updateFormValidity() {
    const allValid = Array.from(this.inputTargets).every(input => {
      const isValid = input.style.borderColor === 'rgb(34, 197, 94)';
      return isValid;
    });

    this.element.dataset.formValid = allValid.toString();
  }
}
